<template>
    <div class="innerBox">
  
      <h1>Laporan Pengunaan Barang</h1>
  
      <panel class="border border-secondary" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter</h4>
        </template>
        <div class="row outerBox filterBox" style="padding : 0 10px !important;">
          <div class="col row">
            <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Tipe Sparepart</label>
              <!-- <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search"> -->
			  <Multiselect 
				:options="options.sparepart_type.map(type => type.id)"
				:custom-label="opt => options.sparepart_type.find(x => x.id == opt).name"
				v-model="filter.sparepart_type_id"
			  />
            </div>
            <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Sparepart Variant</label>
			  <Multiselect 
				:options="options.sparepartVariant.map(type => type.id)"
				:custom-label="opt => options.sparepartVariant.find(x => x.id == opt).name"
				v-model="filter.sparepart_variant_id"
			  />
            </div>
			
			<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Pekerja</label>
              <!-- <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search"> -->
			  <Multiselect
				:options="options.laborer.map(type => type.id)"
				:custom-label="opt => options.laborer.find(x => x.id == opt).name"
				v-model="filter.labourer_id"
			  />
            </div>
			<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Work Order Code</label>
              <!-- <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search"> -->
			  <Multiselect 
			  	:options="options.workorder_code"
				v-model="filter.workorder_code"
			  />
            </div>
            <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Tanggal</label>
              <flat-pickr
                v-model="selected.date"
                :config="rangeConfig"
                placeholder="Pilih Tanggal"
              ></flat-pickr>
            </div>
            <div class="col-md-3 offset-md-6 mt-3" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
              <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
            </div>
          </div>
        </div>
      </panel>
  
	  <vue-universal-table
	  	api_url="/api/v1/inventory/usage"
		:update="vue_universal_table.update"
		:fields="vue_universal_table.fields"
		:special_buttons="vue_universal_table.special_buttons"
		:disable_sort="true"
		:filter="filter"
		:export_config = "vue_universal_table.export_config"
		:process_data="vue_universal_table.process_data"
      ></vue-universal-table>
  
    </div>
  </template>
  
  <script>  
	import Multiselect from 'vue-multiselect'
	import moment from 'moment'

    export default {
		components : {
			Multiselect
		},
		data () {
			return {
				mobile : this.isMobile(),
				modal : {
					view : false,
				},
				rangeConfig: {
					mode: 'range',
					altInput: true,
					altInputClass: 'form-control input flatpickr-input w-100',
					animate: !this.isRTL()
				},
				options : {
					sparepart_type : [
						{id:1,name:'Jasa'},
						{id:2,name:'Part'},
						{id:3,name:'Bahan'}
					],
					laborer : [],
					workorder_code : [],
					sparepartVariant : this.$store.getters.getSparepartVariant()
				},
				detailId : '',
				selected : {
					date : '',
				},
				filter : {
					sparepart_type_id : null,
					workorder_code : null,
					labourer_id : null,
					sparepart_variant_id : null
				},
				vue_universal_table : {
					fields : [
						{
							title : 'Work Order ID',
							variable : 'workorder_code'
						},
						{
							title : 'Nama Pekerja',
							variable : 'labourer_name'
						},
						{
							title : 'Sparepart Name',
							variable : 'sparepart_name'
						},
						{
							title : 'Deskripsi',
							variable : 'description'
						},
						{
							title : 'Jumlah Terpakai',
							variable : 'item_used'
							
						},
						{
							title : 'Tanggal Pemakaian',
							variable : 'transaction_date',
							date_format : 'DD MMM YYYY HH:mm:ss'
						}
					],
					special_buttons : ['exportToExcel'],
					update : 0,
					process_data : `
						for(var i = 0 ; i < data.length ; i++) {
							data[i].sparepart_name = data[i].sparepart_name ? data[i].sparepart_name : '-'
							data[i].workorder_code = data[i].workorder_code ? data[i].workorder_code : '-'
							data[i].labourer_name = data[i].labourer_name ? data[i].labourer_name : '-'
						}
					`,
					export_config : {
						name : 'Inventory Usage',
						type : 'xlsx',
						all : true
					}
				},
			}
		},
		async mounted () {
			this.fetchLaborer();
			this.options.workorder_code = await this.getWorkOrderCode()
		},
		watch : {
			'selected.date'(){
				var date = this.selected.date.split(" to ");
				this.filter.start = date[0]
				this.filter.end = date[1]
			}
		},
		methods : {
			fetchLaborer () {
			this.$http.get(`/api/v1/masterData/labourer?pagination=false`)
			.then((resp)=>{
				this.options.laborer = resp.data.data
			})
			.catch((err)=>{console.log(err)})
			},
		}
    }
  </script>
  
  <style scoped>
  
  </style>